// Reasons a caregiver gives when marking an insight not useful. Each maps to a distinct engine lever
// (detection quality / novelty / clarity / tone & visibility) and is stored verbatim in feedback.note.
export const NOT_USEFUL_REASONS: { key: string; label: string }[] = [
    { key: 'inaccurate', label: 'That’s not right' },
    { key: 'already-knew', label: 'I already knew this' },
    { key: 'unclear', label: 'I don’t understand this' },
    { key: 'unwanted', label: 'I’d rather not see this' }
];

// The label a user picked, resolved from the stored note. Returns undefined for a skipped reason or an
// unrecognized note so callers can fall back to a generic "Not useful".
export const notUsefulReasonLabel = (note?: string): string | undefined => {
    return NOT_USEFUL_REASONS.find(reason => reason.key === note)?.label;
};
